import {UserRole} from 'types';

/**
 * Roles that include all permissions of other roles. MUST match RoleConstant.IMPLIED_ROLES in the
 * backend, which grants the same roles as claims on every request.
 */
const IMPLIED_ROLES: Partial<Record<UserRole, UserRole[]>> = {
	// An AVK administrator can do everything an AVK can, plus maintain machine master data.
	[UserRole.AvkAdministrator]: [UserRole.Avk],
};

/** The given roles plus the roles they imply, without duplicates. */
export const withImpliedRoles = (roles: UserRole[]): UserRole[] => [
	...new Set([...roles, ...roles.flatMap(role => IMPLIED_ROLES[role] ?? [])]),
];
